import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PreguntasFrecuentesService } from '../../../services/util/preguntas-frecuentes.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { FiltroPreguntaDTO, PreguntaFrecuenteDTO } from '../../../dto/preguntas-frecuentes/pregunta-frecuenteDTO';
import { LanguageService } from '../../../services/util/language.service';
import { log } from '@angular-devkit/build-angular/src/builders/ssr-dev-server';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-editar-preguntas-frecuentes',
  templateUrl: './form-editar-preguntas-frecuentes.component.html',
  styleUrl: './form-editar-preguntas-frecuentes.component.scss',
})
export class FormEditarPreguntasFrecuentesComponent {
  @Output() preguntaActualizada = new EventEmitter<void>();
  @ViewChild('modalPreguntasFrecuentes', { static: false })
  modalPreguntasFrecuentes!: ElementRef;
  formularioPreguntas: FormGroup;
  formularioPreguntasCrear: FormGroup;
  preguntaId = 0;

  isEditar: boolean = true;
  categoriasKeys: string[] = [];
  idiomaActual: string = 'es';
  categorias: Map<string, PreguntaFrecuenteDTO[]> = new Map();
  preguntaText: any = {};
  orden: number = 0;
  constructor(
    private fb: FormBuilder,
    private preguntasFrecuentes: PreguntasFrecuentesService,
    private alertService: AlertaModalService,
    private languageService: LanguageService,
    private readonly translate: TranslateService
  ) {
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
      this.buscarPregunta();
    });
    this.formularioPreguntas = this.fb.group({
      pregunta: ['', Validators.required],
      respuesta: ['', Validators.required],
    });

    this.formularioPreguntasCrear = this.fb.group({
      categoria: ['', Validators.required],
      pregunta: ['', Validators.required],
      respuesta: ['', Validators.required],
    });
    combineLatest([
      this.translate.stream('preguntas'),
    ]).subscribe(([preguntasText]) => {
      // Procesar el texto de 'preguntas'
      for (const key of Object.keys(preguntasText)) {
        this.preguntaText[key] = preguntasText[key];
      }
    });
  }

  editarPreguntaFrecuente(pregunta: any) {
    this.isEditar = true;
    this.modalPreguntasFrecuentes.nativeElement.click();
    this.preguntaId = pregunta.Id;
    if (pregunta) {
      this.formularioPreguntas.patchValue({
        pregunta: pregunta.Pregunta_Frecuente || '',
        respuesta:
          pregunta.Respuesta.changingThisBreaksApplicationSecurity ||
          pregunta.Respuesta,
      });
    }
  }

  crearPreguntaFrecuente(orden: number) {
    this.isEditar = false;
    this.modalPreguntasFrecuentes.nativeElement.click();
    this.orden = this.orden+orden;
  }

  onGuardarPreguntaEditada() {
    if (this.formularioPreguntas.valid) {
      const datos = this.formularioPreguntas.value;
      this.preguntasFrecuentes
        .modificarPregunta(this.preguntaId, datos)
        .subscribe({
          next: async () => {
            await this.alertService.exito(this.preguntaText['exito_editar']);
            this.preguntaActualizada.emit();
          },
          error: async () => {
            await this.alertService.error(this.preguntaText['error_editar']);
          },
        });
    }
  }

  onGuardarPregunta() {
    if (this.formularioPreguntasCrear.valid) {
      let datos = this.formularioPreguntasCrear.value;
      datos = {
        ...datos,
        orden: this.orden
      };
      this.preguntasFrecuentes
        .crearPregunta(datos)
        .subscribe({
          next: async () => {
            await this.alertService.exito(this.preguntaText['exito']);
            this.preguntaActualizada.emit();
          },
          error: async () => {
            await this.alertService.error(this.preguntaText['error']);
          },
        });
    }
  }

  buscarPregunta() {
    const json: FiltroPreguntaDTO = {
      busqueda: '',
      idioma: this.idiomaActual
    };
    this.preguntasFrecuentes
      .listarPreguntas(json)
      .subscribe((resp: PreguntaFrecuenteDTO[]) => {
        this.categorias.clear();
        resp.forEach(pregunta => {
          if (!this.categorias.has(pregunta.Categoria)) {
            this.categorias.set(pregunta.Categoria, []);
          }
          this.categorias.get(pregunta.Categoria)?.push(pregunta);
        });
        // Actualiza la propiedad con las llaves
        this.categoriasKeys = Array.from(this.categorias.keys());
      });
  }
}
